import { ReactNode } from "react";
import { RouteObject, useMatches } from "react-router-dom";
import styles from "./breadcrumbs.module.css";

// Define the type for the crumb function
type CrumbFunction = (data: unknown) => ReactNode[];

// Extend the RouteObject interface to include the handle property
type CustomRouteObject<T = unknown> = RouteObject & {
  handle?: {
    crumb?: CrumbFunction;
  };
  data?: T;
};

export default function Breadcrumbs() {
  const matches = useMatches() as CustomRouteObject[];
  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .flatMap((match) => match.handle!.crumb(match.data));

  if (crumbs.length === 1) {
    return null;
  }
  return (
    <div className={styles.container}>
      <ul className={styles.crumbList}>
        {crumbs.map((crumb, index) => (
          <li className={styles.crumb} key={index}>{crumb}</li>
        ))}
      </ul>
    </div>
  );
}